var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportforArtistsinVideoDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.54,174.49C237.8,207,288,214.39,324.09,200.8c40.24-15.14,53.06-63,35.13-100-18.59-38.33-69.51-65.5-111.65-58.63-49.86,8.13-63.29,60.68-44.47,102.12,19.48,42.91,62.82,63.24,100.81,86.62,41.77,25.7,74.47,58.21,87.79,106.56,4.22,15.32,17.19,45.83,2.69,58.15-15.76,13.4-45.69,13.91-64.72,16.05-51.22,5.75-106.45,11.55-157.88,6.09-22.47-2.39-60.3-10.07-70.11-34.14-9.16-22.52,3.67-53,16-71.79,25.59-38.88,69.07-60,110.84-76.61,23.6-9.36,13.31-48-10.61-38.49-73.1,29-152.13,76.95-158.18,164.28-8,115.67,158.66,99.16,231.18,94,25.47-1.8,50.93-4.39,76.14-8.52,19.65-3.23,40.48-8.79,55.52-22.68,30.92-28.55,14.9-78.54,2.63-112.65-15.76-43.82-45.38-76.61-83.18-103-34.26-23.9-85.71-40.56-103.47-81.66-10.13-23.48-1.92-48.56,27-45.45,22,2.37,48.43,17,58.11,37.56,9.27,19.72,1.93,41.88-20.28,46.68-15.32,3.31-44.09,3.39-54.4-11-14.82-20.71-49.46-.8-34.47,20.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportforArtistsinVideoDistribution);
export default __webpack_public_path__ + "static/media/Support for Artists in Video Distribution.8ce400843ef024aaeadfec582611f56c.svg";
export { ForwardRef as ReactComponent };